// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import replaceProduct from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ReplaceProduct";
import updateQuantity from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateQuantity";
import updateUnitOfMeasure from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateUnitOfMeasure";
import translate from "@insite/client-framework/Translate";
import { ProductModel, WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { HiddenProps } from "@insite/mobius/Hidden";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import cloneDeep from "lodash/cloneDeep";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Valtech Custom Code - Start */
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import { productLineProps } from "@store/Themes/common/props/productLine";
/* Valtech Custom Code - End */

interface OwnProps {
    isOpen: boolean;
    handleClose(): void;
    wishList: WishListModel;
    wishListLine: WishListLineModel;
    wishListLines: WishListLineModel[];
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const productInfo = state.pages.myListDetails.replacementProductInfosByWishListLineId[ownProps.wishListLine.id];
    const settingsCollection = getSettingsCollection(state);

    return {
        productInfo,
        settingsCollection,
        loadWishListLinesParameter: state.pages.myListDetails.loadWishListLinesParameter,
    };
};

const mapDispatchToProps = {
    replaceProduct,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ViewReplacementProductStyles {
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    imageGridItem?: GridItemProps;
    imageWrapper?: InjectableCss;
    productImageStyles?: ProductImageStyles;
    descriptionGridItem?: GridItemProps;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    partNumbersGridItem?: GridItemProps;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    partNumbersHidden?: HiddenProps;
    priceStyles?: ProductPriceStyles;
    productInfoContainer?: GridContainerProps;
    cancelLink?: LinkPresentationProps;
    replaceButton?: ButtonPresentationProps;
    headlinePresentaionProps?: TypographyPresentationProps;
    productInformationGridItem?: GridItemProps;
    productPriceGridItem?: GridItemProps;
    buttonsGridItem?: GridItemProps;
    spacingGridItem?: GridItemProps;
    // Valtech Custom Code
    listLineInfoGridItem?: GridItemProps;
    listLineInfoContainer?: GridContainerProps;
    cancelButton?: ButtonPresentationProps;
}

export const viewReplacementProductStyles: ViewReplacementProductStyles = {
    modal: { sizeVariant: "medium" },
    container: productLineProps.contentContainer,
    imageGridItem: productLineProps.imageGridItem,
    productImageStyles: productLineProps.image,
    listLineInfoGridItem: productLineProps.contentGridItem,
    listLineInfoContainer: productLineProps.contentContainer,
    productInformationGridItem: {
        width: [12, 7, 7, 7, 7],
        printWidth: 7,
    },
    productInfoContainer: productLineProps.contentContainer,
    descriptionGridItem: productLineProps.descriptionGridItem,
    productBrandStyles: productLineProps.brand,
    productDescriptionStyles: productLineProps.description,
    partNumbersGridItem: productLineProps.partNumbersGridItem,
    productPriceGridItem: {
        width: [12, 5, 5, 5, 5],
        printWidth: 5,
    },
    priceStyles: productLineProps.price,
    cancelButton: { variant: "secondary" },
};

const styles = viewReplacementProductStyles;

const ViewReplacementProductModal = ({
    isOpen,
    handleClose,
    wishList,
    wishListLines,
    wishListLine,
    productInfo,
    settingsCollection,
    replaceProduct,
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const { productSettings } = settingsCollection;
    const product = mapWishListLineToProduct(wishListLine);

    const onReplaceClick = () => {
        handleClose();

        replaceProduct({
            wishListId: wishList.id,
            wishListLine,
            wishListLines,
        });

        toasterContext.addToast({ body: translate("Item Added"), messageType: "success" });
    };

    if (!product || !productInfo) {
        return null;
    }

    const replacementProductContext: ProductContextModel = {
        product,
        productInfo,

        onQtyOrderedChanged: qtyOrdered => {
            updateQuantity({ wishListLineId: wishListLine.id, qtyOrdered });
        },
        onUnitOfMeasureChanged: unitOfMeasure => {
            updateUnitOfMeasure({ wishListLineId: wishListLine.id, unitOfMeasure });
        },
    };

    return (
        <Modal
            {...styles.modal}
            handleClose={handleClose}
            headline={translate("Replacement Product")}
            isOpen={isOpen}
            // Valtech Removed - size
            isCloseable={true}
            headlineTypographyProps={styles.headlinePresentaionProps}
        >
            <GridContainer {...styles.container} data-test-selector="viewReplacementProduct">
                <GridItem {...styles.imageGridItem}>
                    {/* Valtech Removed - imageWrapper */}
                    <ProductImage product={replacementProductContext} extendedStyles={styles.productImageStyles} />
                </GridItem>
                <GridItem {...styles.listLineInfoGridItem} /* Valtech Custom Code */>
                    <GridContainer {...styles.listLineInfoContainer} /* Valtech Custom Code */>
                        <GridItem {...styles.productInformationGridItem}>
                            <GridContainer {...styles.productInfoContainer} /* Valtech Custom Code */>
                                <GridItem {...styles.descriptionGridItem} /* Valtech Custom Code */>
                                    {replacementProductContext.product.brand && (
                                        <ProductBrand
                                            brand={replacementProductContext.product.brand}
                                            extendedStyles={styles.productBrandStyles}
                                        />
                                    )}
                                    <ProductDescription
                                        product={replacementProductContext}
                                        extendedStyles={styles.productDescriptionStyles}
                                    />
                                </GridItem>
                                <GridItem {...styles.partNumbersGridItem} /* Valtech Custom Code */>
                                    <ProductPartNumbers
                                        productNumber={replacementProductContext.product.productNumber}
                                        customerProductNumber={replacementProductContext.product.customerProductNumber}
                                        manufacturerItem={replacementProductContext.product.manufacturerItem}
                                        extendedStyles={styles.productPartNumbersStyles}
                                    />
                                </GridItem>
                                {/* Valtech Removed - spacingGridItem */}
                                {/* Valtech Moved - productPriceGridItem - down */}
                            </GridContainer>
                        </GridItem>
                        <GridItem {...styles.productPriceGridItem}>
                            <ProductPrice
                                product={replacementProductContext}
                                showSavings={true}
                                /* Valtech Removed - showLabel */
                                /* Valtech Removed - showSalePriceLabel */
                                showSavingsAmount={productSettings.showSavingsAmount}
                                showSavingsPercent={productSettings.showSavingsPercent}
                                extendedStyles={styles.priceStyles}
                            ></ProductPrice>
                        </GridItem>
                    </GridContainer>
                </GridItem>
                {/* Valtech Removed - buttonsGridItem */}
            </GridContainer>
            <FormActions /* Valtech Custom Code */>
                <Button {...styles.replaceButton} onClick={() => onReplaceClick()} data-test-selector="replaceProduct">
                    {translate("Replace")}
                </Button>
                <Button /* Valtech Custom Code */
                    {...styles.cancelButton}
                    onClick={() => handleClose()}
                    data-test-selector="cancelReplaceProduct"
                >
                    {translate("Cancel")}
                </Button>
            </FormActions>
        </Modal>
    );
};

const mapWishListLineToProduct = (wishListLine: WishListLineModel) => {
    if (!wishListLine.replacementProduct) {
        return null;
    }

    const product = cloneDeep(wishListLine.replacementProduct) as any as ProductModel;
    product.id = wishListLine.replacementProduct.id;
    product.productNumber = wishListLine.replacementProduct.erpNumber;
    product.productTitle = wishListLine.replacementProduct.shortDescription;
    product.customerProductNumber = wishListLine.replacementProduct.customerName;
    product.unitOfMeasures =
        wishListLine?.replacementProduct.productUnitOfMeasures?.map(u => ({
            id: u.productUnitOfMeasureId,
            ...u,
        })) || null;

    return product;
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewReplacementProductModal);
